import React from 'react';

import Loader from '../Loader';
import styles from './styles.module.css';

interface ButtonProps {
  label?: string;
  children?: React.ReactNode;
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  icon?: React.ComponentType<{ className?: string }>;
  iconClassName?: string;
  useDefaultStyles?: boolean;
  iconPosition?: 'left' | 'right';
  color?: 'blue' | 'red';
  solid?: boolean;
  loading?: boolean;
  size?: 'small' | 'medium' | 'large';
}

export const Button: React.FC<ButtonProps> = ({
  label = '',
  children,
  className = '',
  onClick,
  type = 'button',
  disabled = false,
  icon: IconComponent,
  iconClassName = '',
  iconPosition = 'left',
  color = 'blue',
  solid = true,
  loading = false,
  size = 'small'
}) => {
  let buttonClassName = `${styles.editButton} ${className}`.trim();

  const iconClass = `${styles.editIcon} ${iconClassName}`.trim();

  switch (size) {
    case 'small':
      buttonClassName += ` ${styles.smallButton}`;
      break;
    case 'medium':
      buttonClassName += ` ${styles.mediumButton}`;
      break;
    case 'large':
      buttonClassName += ` ${styles.largeButton}`;
      break;
  }

  if (color === 'blue') {
    buttonClassName += ` ${styles.blueBorder}`;
    if (solid) {
      buttonClassName += ` ${styles.blueBackground}`;
    }
  } else if (color === 'red') {
    buttonClassName += ` ${styles.redBorder}`;
    if (solid) {
      buttonClassName += ` ${styles.redBackground}`;
    }
  }

  return (
    <div className={styles.buttonContainer}>
      <button
        id={`${label}-button`}
        className={buttonClassName}
        onClick={onClick}
        type={type}
        disabled={disabled}
      >
        {IconComponent && iconPosition === 'left' && (
          <IconComponent className={iconClass} />
        )}
        {label || children}
        {IconComponent && iconPosition === 'right' && (
          <IconComponent className={iconClass} />
        )}
        {loading && <Loader size="small" className={styles.loader} />}
      </button>
    </div>
  );
};
